export default {
  models: {
    admin: {
      user: 'administrateur',
    },
    attributes: {
      admin: {
        user: {
          email: null,
        },
      },
    },
  },
};
